var _defs, _g, _g2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMenuGorneDymek(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "menu_gorne_dymek_svg__a",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#menu_gorne_dymek_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(9 7)",
    fill: "#750b22"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 63"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 88",
    d: "M28.059 13.486a.486.486 0 00-.486-.486h-9.337a.486.486 0 00-.486.486c0 .242 0 .666 1.771.9v6.767c-1.09.509-1.771 1.265-1.771 2.125a.486.486 0 00.486.486h3.138c.22 3.388.61 5.809 1.111 6.663l.4.686.427-.671c.518-.815.911-3.216 1.13-6.678h3.128a.486.486 0 00.486-.486c0-.859-.681-1.616-1.771-2.125v-6.767c1.771-.234 1.774-.658 1.774-.9zm-7.565.993c.642.044 1.433.07 2.411.07s1.769-.026 2.411-.07v6.316a9.391 9.391 0 00-4.822 0zm2.418 14.126a37.764 37.764 0 01-.565-4.843h1.122a37.516 37.516 0 01-.558 4.844zm4-5.816h-8.017c.494-.7 2-1.337 4.009-1.337s3.516.637 4.009 1.338z",
    fill: "#fff"
  }))));
}

export default SvgMenuGorneDymek;